import { render, staticRenderFns } from "./ResultsList.vue?vue&type=template&id=98ed09d6"
import script from "./ResultsList.vue?vue&type=script&lang=js"
export * from "./ResultsList.vue?vue&type=script&lang=js"
import style0 from "./ResultsList.vue?vue&type=style&index=0&id=98ed09d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports